import { render, staticRenderFns } from "./vue-tabs.vue?vue&type=template&id=7e30a791"
import script from "./vue-tabs.vue?vue&type=script&lang=js"
export * from "./vue-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@5.2.7_webpack@5.111.0__lodash@4.18.1_vu_d5766d53fa3af55ecda13d456ae73cbe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/phuongle/Documents/Accolade/AW-260/accoladewines-branded-sites-astro/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e30a791')) {
      api.createRecord('7e30a791', component.options)
    } else {
      api.reload('7e30a791', component.options)
    }
    module.hot.accept("./vue-tabs.vue?vue&type=template&id=7e30a791", function () {
      api.rerender('7e30a791', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/vue-tabs.vue"
export default component.exports